import React from "react";
import "./CustomAccordian.css";
const CustomAccordian = () => {
    return (
        <div class="card">
            <div class="card-front">Hi</div>
            <div class="card-back">hELLO</div>
        </div>
    );
};

export default CustomAccordian;
